<template>
  <Toast />
  <Dialog
    v-model:visible="activarModal"
    :style="{ width: '900px' }"
    header="DETALLE PRODUCTOS"
    :modal="true"
    :closable="false"
    @hide="closeModal"
    class="p-fluid"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <!-- DATOS BÁSICOS - Siempre primero -->
        <div class="col-12 lg:col-8 order-1">
          <div class="estilos-card">
            <div class="card-header mb-3">
              <i class="pi pi-box"></i>
              <span>DATOS BÁSICOS</span>
            </div>

            <div class="grid">
              <div class="field col-12 md:col-4">
                <strong>TIPO: <span class="p-invalid">*</span></strong>
                <Dropdown
                  v-model="data_producto.tipo_catalogo"
                  :options="tipos_catalogo"
                  optionLabel="label"
                  optionValue="value"
                  @change="changeTipoCatalogo"
                  :disabled="data_producto.id !== null && data_producto.id !== undefined"
                />
              </div>

              <div class="field col-12 md:col-8">
                <strong>DESCRIPCIÓN: <span class="p-invalid">*</span></strong>
                <Textarea
                  placeholder="Nombre del producto/servicio"
                  v-model="data_producto.descripcion"
                  rows="1"
                  autoResize
                />
                <small class="p-invalid" v-if="errors.descripcion">
                  {{ errors.descripcion[0] }}
                </small>
              </div>

              <div class="field col-12 md:col-4">
                <strong
                  >CÓD. INTERNO:
                  <span class="p-invalid" v-if="facturar_producto == 1">*</span>
                </strong>
                <InputText placeholder="Código Interno" v-model="data_producto.codigo_interno" />
                <small class="p-invalid" v-if="errors.codigo_interno">
                  {{ errors.codigo_interno[0] }}
                </small>
              </div>

              <div class="field col-12 md:col-4" v-if="data_producto.tipo_catalogo == 1 && vender_con_codigo_barra">
                <strong>CÓD. BARRAS:</strong>
                <InputText placeholder="Código de Barras" v-model="data_producto.codigo_barra" />
              </div>

              <div class="field col-12 md:col-4" v-if="data_producto.tipo_catalogo == 1 && mostrar_codigo_origen">
                <strong>CÓD. ORIGEN:</strong>
                <InputText placeholder="Fabricante" v-model="data_producto.codigo_origen" />
              </div>

              <div class="field col-12 md:col-4" v-if="data_producto.tipo_catalogo == 1 && mostrar_medidas">
                <strong>DIMENSIONES:</strong>
                <InputText placeholder="10x20x30 cm" v-model="data_producto.medidas" />
              </div>

              <div class="field col-12 md:col-8" v-if="data_producto.tipo_catalogo == 1 && mostrar_codigo_equivalente">
                <strong>CÓD. EQUIVALENTE:</strong>
                <Textarea
                  placeholder="Código Equivalente"
                  v-model="data_producto.codigo_equivalente"
                  rows="1"
                  autoResize
                />
              </div>
              <div class="field col-12 md:col-4">
                <strong>ESTADO:</strong>
                <Dropdown
                  v-model="data_producto.estado"
                  :disabled="!data_producto.id"
                  :options="estados"
                  optionLabel="label"
                >
                  <template #value="slotProps">
                    <span :class="'product-badge ' + claseEstado[slotProps.value.value]">
                      {{ slotProps.value.label }}
                    </span>
                  </template>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>

        <!-- CLASIFICACIÓN - Segundo en desktop, tercero en móvil -->
        <div class="col-12 lg:col-4 order-3 lg:order-2">
          <div class="estilos-card">
            <div class="card-header mb-3">
              <i class="pi pi-tags"></i>
              <span>CLASIFICACIÓN</span>
            </div>

            <div class="grid">
              <div class="col-12">
                <div class="field">
                  <strong>MARCA: <span class="p-invalid">*</span></strong>
                  <div class="p-inputgroup">
                    <Dropdown
                      v-model="laboratorioSelect"
                      :options="laboratorios"
                      optionLabel="nombre"
                      :filter="true"
                      placeholder="Seleccione..."
                    >
                      <template #option="slotProps">
                        <span v-if="data_producto.tipo_catalogo == 1">
                          {{ slotProps.option.nombre }} -
                          {{ slotProps.option.nombre_proveedor }}
                        </span>
                        <span v-else>{{ slotProps.option.nombre }}</span>
                      </template>
                    </Dropdown>
                    <Button
                      v-if="'Laboratorio Crear' in auth.user.permissions"
                      icon="pi pi-plus"
                      @click="activarLaboratorioModal"
                    />
                  </div>
                  <small class="p-invalid" v-if="errors.fabrica_id">
                    {{ errors.fabrica_id[0] }}
                  </small>
                </div>

                <div class="field" v-if="'Grupo Crear' in auth.user.permissions">
                  <strong>GRUPO:</strong>
                  <div class="p-inputgroup">
                    <Dropdown
                      v-model="grupoSelect"
                      :options="grupos"
                      optionLabel="nombre"
                      :filter="true"
                      placeholder="Seleccione..."
                    />
                    <Button icon="pi pi-plus" @click="activarGrupoModal" />
                  </div>
                </div>

                <div class="field" v-if="data_producto.tipo_catalogo == 1">
                  <strong>PROCEDENCIA:</strong>
                  <div class="p-inputgroup">
                    <Dropdown
                      v-model="procedenciaSelect"
                      :options="procedencias"
                      optionLabel="nombre"
                      :filter="true"
                      placeholder="Seleccione..."
                    />
                    <Button icon="pi pi-plus" @click="activarProcedenciaModal" />
                  </div>
                </div>

                <div class="field">
                  <strong>U.MEDIDA: <span class="p-invalid">*</span></strong>
                  <div class="p-inputgroup">
                    <Dropdown
                      v-model="unidadSelect"
                      :options="unidadesmedidas"
                      :filter="true"
                      optionLabel="nombre"
                      placeholder="Seleccione..."
                    />
                    <Button
                      v-if="'Unidad de Medida Crear' in auth.user.permissions"
                      icon="pi pi-plus"
                      @click="activarUnidadMedidaModal"
                    />
                  </div>
                  <small class="p-invalid" v-if="errors.unidadmedida_id">
                    {{ errors.unidadmedida_id[0] }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- INVENTARIO/PRECIOS - Segundo en móvil -->
        <div class="col-12 mt-2 order-2 lg:order-3">
          <div class="estilos-card">
            <div class="card-header mb-3">
              <i class="pi pi-database"></i>
              <span>INVENTARIO/PRECIOS</span>
            </div>
            <div class="grid">
              <div class="field col-12 md:col-4">
                <strong>SUCURSAL:</strong>
                <Dropdown
                  v-model="sucursalSelect"
                  :options="sucursales"
                  optionLabel="nombre"
                  @change="changeSucursal"
                  :filter="true"
                />
              </div>

              <div class="field col-12 md:col-3" v-if="data_producto.tipo_catalogo == 1">
                <strong>UBICACIÓN:</strong>
                <Textarea v-model="data_producto.ubicacion" :rows="1" placeholder="Estante, pasillo..." autoResize />
              </div>

              <div class="field col-12 md:col-3" v-if="data_producto.tipo_catalogo == 1">
                <strong>CASO DE USO:</strong>
                <Textarea v-model="data_producto.caso_uso" :rows="1" placeholder="Descripción del uso..." autoResize />
              </div>

              <div class="field col-12 md:col-2" v-if="data_producto.tipo_catalogo == 1">
                <strong>STOCK MÍNIMO:</strong>
                <InputNumber v-model="data_producto.stock_minimo" :inputClass="'text-right'" :min="0" />
                <small class="p-invalid" v-if="errors.stock_minimo">
                  {{ errors.stock_minimo[0] }}
                </small>
              </div>

              <div class="field col-12 md:col-4" v-if="data_producto.tipo_catalogo == 1">
                <strong>STOCK ACTUAL:</strong>
                <InputNumber
                  v-model="data_producto.stock_actual"
                  :inputClass="'text-right'"
                  :min="0"
                  :minFractionDigits="stock_decimales ? 2 : 0"
                  :maxFractionDigits="stock_decimales ? 2 : 0"
                  mode="decimal"
                  locale="de-ED"
                  :disabled="!actualizar_precio_compra"
                />
              </div>

              <div class="field col-12 md:col-4">
                <strong>{{ data_producto.tipo_catalogo == 1 ? 'P.U. COMPRA:' : 'COSTO:' }}</strong>
                <div class="p-inputgroup">
                  <InputNumber
                    v-model="data_producto.precio_compra"
                    :inputClass="'text-right'"
                    :minFractionDigits="2"
                    :maxFractionDigits="2"
                    locale="de-ED"
                    :disabled="!actualizar_precio_compra"
                  />
                  <Button
                    :disabled="!('Producto Actualizar' in auth.user.permissions)"
                    class="p-button-info"
                    icon="pi pi-pencil"
                    @click="activarActualizarPrecioCompra"
                    v-tooltip.top="'Actualizar precio'"
                  />
                </div>
              </div>

              <div class="field col-12 md:col-4">
                <strong>P. VENTA:</strong>
                <div class="p-inputgroup">
                  <InputNumber
                    v-model="data_producto.precio_sugerido"
                    :inputClass="'text-right'"
                    :min="0"
                    :minFractionDigits="2"
                    :maxFractionDigits="2"
                    locale="de-ED"
                    :disabled="data_producto.id && !actualizar_precio_venta"
                  />
                  <Button
                    v-if="'Producto Actualizar' in auth.user.permissions"
                    :disabled="!data_producto.id"
                    class="p-button-info"
                    icon="pi pi-pencil"
                    @click="activarActualizarPrecioVenta"
                    v-tooltip.top="'Actualizar precio'"
                  />
                </div>
                <small class="p-invalid" v-if="errors.precio_sugerido">
                  {{ errors.precio_sugerido[0] }}
                </small>
              </div>

              <div class="field col-12 md:col-4" v-if="maneja_mas_de_un_precio">
                <strong>P. MAYORISTA:</strong>
                <InputNumber
                  v-model="data_producto.pv2"
                  :inputClass="'text-right'"
                  :min="0"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                  locale="de-ED"
                  :disabled="data_producto.id && !actualizar_precio_venta"
                />
              </div>

              <div class="field col-12 md:col-4" v-if="data_producto.tipo_catalogo != 1">
                <strong>COMISIÓN:</strong>
                <InputNumber
                  v-model="data_producto.comision_medico"
                  :inputClass="'text-right'"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                  locale="de-ED"
                  :disabled="!data_producto.es_comisionable"
                  :max="data_producto.precio_sugerido"
                />
              </div>

              <div class="field col-12 md:col-4" v-if="data_producto.tipo_catalogo != 1">
                <strong>&nbsp;</strong>
                <div class="field-checkbox">
                  <Checkbox v-model="data_producto.es_comisionable" :binary="true" inputId="es_comisionable" />
                  <label for="es_comisionable" class="ml-2">
                    <strong>ES COMISIONABLE</strong>
                  </label>
                </div>
              </div>

              <div class="field col-12 md:col-4" v-if="data_producto.tipo_catalogo == 1 && mostrar_cif">
                <strong>PRECIO FOB:</strong>
                <InputNumber
                  v-model="data_producto.precio_cif"
                  :inputClass="'text-right'"
                  :min="0"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                  locale="de-ED"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- INFORMACIÓN ADICIONAL -->
        <div class="col-12 lg:col-4 mt-2 order-4">
          <div class="estilos-card">
            <div class="card-header mb-3">
              <i class="pi pi-info-circle"></i>
              <span>INFORMACIÓN ADICIONAL</span>
            </div>

            <div class="grid">
              <div class="col-12">
                <div class="field">
                  <strong>OBSERVACIONES:</strong>
                  <Textarea
                    v-model="data_producto.observacion"
                    :rows="1"
                    placeholder="Notas adicionales..."
                    autoResize
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- HOMOLOGACIÓN FISCAL -->
        <div class="col-12 lg:col-8 mt-2 order-5" v-if="'Producto Homologar' in auth.user.permissions">
          <div class="estilos-card">
            <div class="card-header mb-3">
              <i class="pi pi-shield"></i>
              <span>HOMOLOGACIÓN FISCAL (SIAT)</span>
              <span v-if="data_producto.facturado == 1" class="badge-homologado ml-auto">
                <i class="pi pi-check mr-1"></i>HOMOLOGADO
              </span>
            </div>

            <div class="grid">
              <div class="col-12">
                <div class="field-checkbox">
                  <Checkbox
                    v-model="facturar_producto"
                    :binary="true"
                    :disabled="data_producto.facturado == 1"
                    inputId="homologar"
                  />
                  <label for="homologar" class="ml-2">
                    <strong>HOMOLOGAR PRODUCTO</strong>
                  </label>
                </div>
              </div>

              <div class="col-12">
                <div class="field">
                  <strong>CÓDIGO SIAT:</strong>
                  <Dropdown
                    v-model="codigoSINSelect"
                    :options="codigossin"
                    :filter="true"
                    optionLabel="descripcionProducto"
                    placeholder="Seleccione..."
                  >
                    <template #option="slotProps">
                      <span v-tooltip.top="slotProps.option.descripcionProducto">
                        {{
                          slotProps.option.descripcionProducto.length > 80
                            ? slotProps.option.descripcionProducto.substring(0, 80) + '...'
                            : slotProps.option.descripcionProducto
                        }}
                      </span>
                    </template>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="field">
        <span class="flex md:justify-content-start">
          <strong>CAMPOS REQUERIDOS: </strong>
          <span class="p-invalid">*</span>
        </span>
      </div>
      <Button label="CANCELAR" icon="pi pi-times" class="p-button-secondary p-button-lg" @click="closeModal" />
      <Button
        :label="data_producto.id == null ? 'GUARDAR' : 'ACTUALIZAR'"
        icon="pi pi-save"
        class="p-button-info p-button-lg"
        :loading="enviado"
        @click="guardarProducto"
      />
    </template>
  </Dialog>

  <!-- Modales auxiliares -->
  <UnidadMedidaCreate
    v-if="UnidadMedidaModal"
    :show="UnidadMedidaModal"
    :unidadmedida="unidadMedida"
    @closeModal="cerrarModalUnidadMedida"
    @actualizarListado="cargarUnidadesMedidas"
  />
  <LaboratorioCreate
    v-if="LaboratorioModal"
    :mostrar="LaboratorioModal"
    :laboratorio="laboratorio"
    @closeModal="cerrarModalLaboratorio"
    @actualizarListadoLaboratorio="cargarLaboratorios"
  />
  <GrupoCreate
    v-if="GrupoModal"
    :show="GrupoModal"
    :grupo="grupo"
    @closeModal="cerrarModalGrupo"
    @actualizarListado="cargarGrupos"
  />
  <SubGrupoCreate
    v-if="SubGrupoModal"
    :show="SubGrupoModal"
    :subgrupo="subgrupo"
    @closeModal="cerrarModalSubGrupo"
    @actualizarListado="cargarSubGrupos"
  />
  <ProcedenciaCreate
    v-if="ProcedenciaModal"
    :show="ProcedenciaModal"
    :procedencia="procedencia"
    @closeModal="cerrarModalProcedencia"
    @actualizarListado="cargarProcedencias"
  />
</template>

<script>
import UnidadMedidaCreate from '@/module/unidadmedida/UnidadMedidaCreate.vue'
import LaboratorioCreate from '@/module/laboratorios/LaboratorioCreate.vue'
import ProductService from '@/service/ProductService'
import LaboratorioService from '@/service/LaboratorioService'
import UnidadmedidaService from '@/service/UnidadmedidaService'
import { useAuth } from '@/stores'
import SucursalService from '@/service/SucursalService'
import GrupoService from '@/service/GrupoService'
import SubGrupoService from '@/service/SubGrupoService'
import ProcedenciaService from '@/service/ProcedenciaService'
import GrupoCreate from '@/module/grupos/GrupoCreate.vue'
import SubGrupoCreate from '@/module/subgrupos/SubGrupoCreate.vue'
import ProcedenciaCreate from '@/module/procedencias/ProcedenciaCreate.vue'

export default {
  components: {
    UnidadMedidaCreate,
    LaboratorioCreate,
    GrupoCreate,
    ProcedenciaCreate,
    SubGrupoCreate
  },
  emits: ['closeModal', 'actualizarListadoProductos'],
  props: {
    mostrar: {
      type: Boolean,
      default: false
    },
    producto: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  productoService: null,
  laboratorioService: null,
  unidadmedidaService: null,
  sucursalService: null,
  auth: null,
  grupoService: null,
  subgrupoService: null,
  procedenciaService: null,
  data() {
    return {
      activarModal: this.mostrar,
      data_producto: this.producto,
      laboratorios: {},
      unidadesmedidas: {},
      laboratorioSelect: {},
      unidadSelect: {},
      UnidadMedidaModal: false,
      LaboratorioModal: false,
      laboratorio: { estado: { label: 'Activo', value: 1 } },
      unidadMedida: { estado: { label: 'Activo', value: 1 } },
      estados: [
        { label: 'Inactivo', value: 0 },
        { label: 'Activo', value: 1 }
      ],
      enviado: false,
      errors: {},
      claseEstado: ['status-outofstock', 'status-instock'],
      stock_minimo: 0,
      stock_maximo: 0,
      precio_sugerido: 0,
      actualizar_precio_compra: 0,
      actualizar_precio_venta: 0,
      sucursalSelect: null,
      sucursales: [],
      //si data_producto.facturado == 1, entonces facturar_producto = 1
      facturar_producto: 0,
      codigoSINSelect: { label: 'Seleccione un codigo siat', value: null },
      unidadMedidaSelect: {},
      codigossin: [],
      tipos_catalogo: [
        { label: 'PRODUCTO', value: 1 },
        { label: 'SERVICIO', value: 2 }
      ],
      grupos: {},
      grupo: { estado: { label: 'Activo', value: 1 } },
      grupoSelect: {},
      procedencias: {},
      subgrupos: {},
      subgrupo: { estado: { label: 'Activo', value: 1 } },
      subgrupoSelect: {},
      procedencia: { estado: { label: 'Activo', value: 1 } },
      procedenciaSelect: {},
      GrupoModal: false,
      SubGrupoModal: false,
      ProcedenciaModal: false,
      parametros_sistema: {},
      mostrar_cif: false,
      stock_decimales: false,
      maneja_mas_de_un_precio: false,

      vender_con_codigo_barra: false,
      mostrar_codigo_origen: false,
      mostrar_codigo_equivalente: false,
      mostrar_medidas: false
    }
  },
  created() {
    this.auth = useAuth()
    this.productoService = new ProductService()
    this.laboratorioService = new LaboratorioService()
    this.unidadmedidaService = new UnidadmedidaService()
    this.sucursalService = new SucursalService()
    this.grupoService = new GrupoService()
    this.subgrupoService = new SubGrupoService()
    this.procedenciaService = new ProcedenciaService()
  },
  mounted() {
    /* this.cargarLaboratorios();
    this.cargarUnidadesMedidas();
    this.cargarSucursales();
    this.cargarCodigosSIN(); */
    this.getDatosNecesariosProducto()
  },
  methods: {
    activarActualizarPrecioCompra() {
      this.actualizar_precio_compra = !this.actualizar_precio_compra
    },
    activarActualizarPrecioVenta() {
      this.actualizar_precio_venta = !this.actualizar_precio_venta
    },
    changeTipoCatalogo() {
      if (this.data_producto.tipo_catalogo != 1) {
        this.data_producto.stock_actual = 999999999
        this.actualizar_precio_compra = true
      } else {
        this.data_producto.stock_actual = 0
        this.actualizar_precio_compra = false
      }
    },
    getDatosNecesariosProducto() {
      this.productoService.getDatosNecesariosProducto().then((response) => {
        this.laboratorios = response.datos.fabricas ?? []
        this.unidadesmedidas = response.datos.unidadmedida ?? []
        this.codigossin = response.datos.codigossin ?? []
        this.sucursales = response.datos.sucursales || []
        this.sucursalSelect = this.sucursales[0].id || null
        this.grupos = response.datos.grupos ?? []
        this.subgrupos = response.datos.subgrupos ?? []
        this.procedencias = response.datos.procedencias ?? []
        this.parametros_sistema = response.datos.parametros_sistema ?? []
        this.parametros_sistema.some((element) => {
          if (element.nombre == 'mostrar_cif') {
            this.mostrar_cif = true
          }
          if (element.nombre == 'stock_decimales') {
            this.stock_decimales = true
          }
          if (element.nombre == 'maneja_mas_de_un_precio') {
            this.maneja_mas_de_un_precio = true
          }
          if (element.nombre == 'vender_con_codigo_barra') {
            this.vender_con_codigo_barra = true
          }
          if (element.nombre == 'mostrar_codigo_origen') {
            this.mostrar_codigo_origen = true
          }
          if (element.nombre == 'mostrar_codigo_equivalente') {
            this.mostrar_codigo_equivalente = true
          }
          if (element.nombre == 'mostrar_medidas') {
            this.mostrar_medidas = true
          }
        })
      })
    },
    cargarGrupos(grupo = null) {
      this.grupoService
        .getGrupoAll()
        .then((response) => {
          this.grupos = response.grupos
          if (grupo) {
            this.grupos.forEach((element) => {
              if (element.id == grupo.id) {
                this.grupoSelect = element
              }
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    cargarSubGrupos(subgrupo = null) {
      this.subgrupoService
        .getSubGrupoAll()
        .then((response) => {
          this.subgrupos = response.subgrupos
          if (subgrupo) {
            this.subgrupos.forEach((element) => {
              if (element.id == subgrupo.id) {
                this.subgrupoSelect = element
              }
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    cargarProcedencias(procedencia = null) {
      this.procedenciaService
        .getProcedenciaAll()
        .then((response) => {
          this.procedencias = response.procedencias
          if (procedencia) {
            this.procedencias.forEach((element) => {
              if (element.id == procedencia.id) {
                this.procedenciaSelect = element
              }
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    activarGrupoModal() {
      this.GrupoModal = true
      this.grupo = {
        estado: { label: 'ACTIVO', value: 1 }
      }
    },
    cerrarModalGrupo() {
      this.GrupoModal = false
      this.subgrupo = {}
    },
    activarSubGrupoModal() {
      this.SubGrupoModal = true
      this.subgrupo = {
        estado: { label: 'ACTIVO', value: 1 }
      }
    },
    cerrarModalSubGrupo() {
      this.GrupoModal = false
      this.grupo = {}
    },
    activarProcedenciaModal() {
      this.ProcedenciaModal = true
      this.procedencia = {
        estado: { label: 'Activo', value: 1 }
      }
    },
    cerrarModalProcedencia() {
      this.ProcedenciaModal = false
      this.procedencia = {}
    },
    cargarCodigosSIN() {
      this.productoService
        .getCodigoSIN()
        .then((response) => {
          this.codigossin = response.codigossin || []
          if (response.status == 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Exito',
              detail: response.message,
              life: 3000
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    cargarSucursales() {
      this.sucursalService.getSucursalesAll().then((response) => {
        this.sucursales = response
        this.sucursalSelect = this.sucursales[0] ?? null
      })
    },
    cerrarModalLaboratorio() {
      this.LaboratorioModal = false
      this.laboratorio = {}
    },
    cerrarModalUnidadMedida() {
      this.UnidadMedidaModal = false
      this.unidadMedida = {}
    },
    activarLaboratorioModal() {
      this.LaboratorioModal = true
      this.laboratorio = {
        estado: { label: 'Activo', value: 1 }
      }
    },
    activarUnidadMedidaModal() {
      this.UnidadMedidaModal = true
      this.unidadMedida = {
        estado: { label: 'Activo', value: 1 }
      }
    },
    cargarLaboratorios(fabrica = null) {
      this.laboratorioService
        .getAllLaboratorios()
        .then((response) => {
          this.laboratorios = response.fabricas
          if (fabrica) {
            this.laboratorios.forEach((element) => {
              if (element.id == fabrica.id) {
                this.laboratorioSelect = element
              }
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    cargarUnidadesMedidas(unidadmedida = null) {
      this.unidadmedidaService
        .getUnidadmedidasAll()
        .then((response) => {
          this.unidadesmedidas = response
          if (unidadmedida) {
            this.unidadesmedidas.forEach((element) => {
              if (element.id == unidadmedida.id) {
                this.unidadSelect = element
              }
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    closeModal() {
      this.errors = {}
      this.laboratorioSelect = {}
      this.unidadSelect = {}
      this.activarModal = false
      this.$emit('closeModal')
      this.actualizar_precio_compra = 0
      this.sucursalSelect = this.sucursales[0]
      this.actualizar_precio_venta = 0
      this.facturar_producto = 0
      this.codigoSINSelect = {}
      this.unidadMedidaSelect = {}
      this.enviado = false
      this.grupoSelect = {}
      this.subgrupoSelect = {}
      this.procedenciaSelect = {}
    },
    guardarProducto() {
      if (
        (this.facturar_producto == 1 && this.data_producto.codigo_interno == null) ||
        this.data_producto.codigo_interno === ''
      ) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Debe ingresar un codigo interno para el producto',
          life: 3000
        })
        return
      }
      /* if (this.subgrupoSelect == null) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe seleccionar un subgrupo",
          life: 3000,
        });
        return;
      } */
      this.errors = {}
      this.enviado = true
      if (this.data_producto.id) {
        //Actualizar
        let tmp = {
          ...this.data_producto,
          estado: this.data_producto.estado.value,
          fabrica_id: this.laboratorioSelect.id,
          unidadmedida_id: this.unidadSelect.id,
          actualizar_precio_compra: this.actualizar_precio_compra ? 1 : 0,
          actualizar_precio_venta: this.actualizar_precio_venta ? 1 : 0,
          sucursal_id: this.sucursalSelect?.id ?? null,
          stock_actual: this.data_producto.stock_actual ?? 0,
          facturar_producto: this.data_producto.facturado ? 1 : this.facturar_producto ? 1 : 0,
          codigo_siat: this.codigoSINSelect?.codigoProducto ?? null,
          grupo_id: this.grupoSelect?.id ?? 1,
          subgrupo_id: this.subgrupoSelect?.id ?? 1,
          procedencia_id: this.procedenciaSelect?.id ?? null,
          precio_cif: this.data_producto.precio_cif ?? 0,

          // Siempre presentes aunque estén vacíos
          codigo_barra: this.data_producto.codigo_barra ?? '',
          codigo_origen: this.data_producto.codigo_origen ?? '',
          codigo_equivalente: this.data_producto.codigo_equivalente ?? '',
          medidas: this.data_producto.medidas ?? '',
          ubicacion: this.data_producto.ubicacion ?? '',
          observacion: this.data_producto.observacion ?? '',
          caso_uso: this.data_producto.caso_uso ?? ''
        }

        this.productoService.actualizarProducto(tmp).then((response) => {
          if (Object.prototype.hasOwnProperty.call(response, 'errors')) {
            this.errors = response.errors
            this.$toast.add({
              severity: 'error',
              summary: 'Error!',
              detail: this.errors,
              life: 9000
            })
          } else {
            this.errors = {}
            if (response.status == 400) {
              this.$toast.add({
                severity: 'error',
                summary: 'Error!',
                detail: response.mensaje,
                life: 3000
              })
              this.enviado = false
              return
            } else {
              this.$toast.add({
                severity: 'success',
                summary: 'Actualizado!',
                detail: response.mensaje,
                life: 3000
              })
              this.$emit('actualizarListadoProductos')
              this.$emit('closeModal')
            }
          }
          this.enviado = false
        })
      } else {
        //Registrar nuevo producto
        if (this.laboratorioSelect == null) {
          this.$toast.add({
            severity: 'error',
            summary: 'Error!',
            detail: 'Debe seleccionar un laboratorio',
            life: 3000
          })
          this.enviado = false
          return
        }
        if (this.unidadSelect == null) {
          this.$toast.add({
            severity: 'error',
            summary: 'Error!',
            detail: 'Debe seleccionar una unidad de medida',
            life: 3000
          })
          this.enviado = false
          return
        }
        let tmp = {
          ...this.data_producto,
          estado: this.data_producto.estado.value,
          fabrica_id: this.laboratorioSelect.id,
          unidadmedida_id: this.unidadSelect.id,
          facturar_producto: this.facturar_producto ? 1 : 0,
          unidad_medida_sin: this.unidadMedidaSelect.id,
          codigo_siat: this.codigoSINSelect != null ? this.codigoSINSelect.codigoProducto : null,
          actualizar_precio_compra: this.actualizar_precio_compra ? 1 : 0,
          actualizar_precio_venta: this.actualizar_precio_venta ? 1 : 0,
          sucursal_id: this.sucursalSelect.id ?? null,
          stock_actual: this.data_producto.stock_actual ?? 0,
          grupo_id: this.grupoSelect?.id ?? 1,
          subgrupo_id: this.subgrupoSelect?.id ?? 1,
          procedencia_id: this.procedenciaSelect?.id,
          precio_cif: this.data_producto.precio_cif ?? 0,
          codigo_interno: this.data_producto.codigo_interno ?? ''
        }
        this.productoService.registrarProducto(tmp).then((response) => {
          if (Object.prototype.hasOwnProperty.call(response, 'errors')) {
            this.errors = response.errors
            this.$toast.add({
              severity: 'error',
              summary: 'Error!',
              detail: response.mensaje,
              life: 3000
            })
          } else {
            this.errors = {}
            if (response.status == 400) {
              this.$toast.add({
                severity: 'error',
                summary: 'Error!',
                detail: response.mensaje,
                life: 3000
              })
              this.enviado = false
              return
            } else {
              this.$toast.add({
                severity: 'success',
                summary: 'Exito!',
                detail: response.mensaje,
                life: 3000
              })
              this.$emit('actualizarListadoProductos')
              this.$emit('closeModal')
            }
          }
          this.enviado = false
        })
      }
    },
    findIndex(id) {
      let index = -1
      for (let i = 0; i < this.productos.length; i++) {
        if (this.productos[i].id === id) {
          index = i
          break
        }
      }
      return index
    },
    textoEstado(estado) {
      return estado == 1 ? 'Activo' : 'Inactivo'
    },
    changeSucursal() {
      let datos = {
        producto_id: this.data_producto.id,
        sucursal_id: this.sucursalSelect.id
      }
      this.productoService.getProductoSucursal(datos).then((response) => {
        if (response.stock.length == 0) {
          if (this.data_producto.tipo_catalogo == 1) {
            this.data_producto.stock_actual = 0
          } else {
            this.data_producto.stock_actual = 999999999
          }
          this.data_producto.precio_compra = 0
          this.data_producto.precio_sugerido = this.data_producto.precio_sugerido ?? 0
          this.data_producto.ubicacion = this.data_producto.ubicacion ?? ''
          this.data_producto.comision_medico = 0
          this.data_producto.es_comisionable = false
          this.$toast.add({
            severity: 'info',
            summary: 'Cambio de sucursal!',
            detail: 'Se cargaron los datos de la sucursal seleccionada',
            life: 3000
          })
          return
        }
        this.data_producto.stock_actual = parseFloat(response.stock[0].cantidad ?? 0)
        this.data_producto.precio_compra = parseFloat(response.stock[0].precio_compra ?? 0)
        this.data_producto.precio_sugerido = parseFloat(response.stock[0].precio_venta ?? 0)
        this.data_producto.pv2 = parseFloat(response.stock[0].pv2 ?? 0)
        this.data_producto.pv3 = parseFloat(response.stock[0].pv3 ?? 0)
        this.data_producto.pv4 = parseFloat(response.stock[0].pv4 ?? 0)
        this.data_producto.pv5 = parseFloat(response.stock[0].pv5 ?? 0)
        this.data_producto.ubicacion = response.stock[0].ubicacion ?? ''
        this.data_producto.comision_medico = parseFloat(response.stock[0].comision_medico ?? 0)
        this.data_producto.precio_cif = parseFloat(response.stock[0].precio_cif ?? 0)
        this.data_producto.es_comisionable = Boolean(response.stock[0].es_comisionable ?? 0)
        this.$toast.add({
          severity: 'info',
          summary: 'Cambio de sucursal!',
          detail: 'Se cargaron los datos de la sucursal seleccionada',
          life: 3000
        })
      })
    }
  },
  watch: {
    mostrar(newVal) {
      this.activarModal = newVal
    },

    producto(newVal) {
      this.data_producto = newVal

      this.data_producto = newVal

      if (this.data_producto.id != null && this.data_producto.codigo_siat) {
        this.productoService
          .getCodigosSiatPorActividad({
            codigo_siat: this.data_producto.codigo_siat
          })
          .then((response) => {
            this.codigossin = response.codigossin ?? []
            this.codigoSINSelect =
              this.codigossin.find((codigo) => codigo.codigoProducto == this.data_producto.codigo_siat) || null
          })
      }

      // Cuando es nuevo producto que cargue el primer elemento de cada lista que tenga el id 1
      if (this.data_producto.id == null) {
        // Si es nuevo, habilito actualizar_precio_compra
        this.actualizar_precio_compra = true

        if (typeof this.data_producto.estado === 'number') {
          this.data_producto.estado = this.estados.find((e) => e.value === this.data_producto.estado) || this.estados[1] // Por defecto Activo
        }

        // Verificar que los arrays estén cargados antes de hacer .find()
        if (Array.isArray(this.grupos) && this.grupos.length > 0) {
          this.grupoSelect = this.grupos.find((grupo) => grupo.id == 1) || null
        }

        if (Array.isArray(this.subgrupos) && this.subgrupos.length > 0) {
          this.subgrupoSelect = this.subgrupos.find((subgrupo) => subgrupo.id == 1) || null
        }

        if (Array.isArray(this.procedencias) && this.procedencias.length > 0) {
          this.procedenciaSelect = this.procedencias.find((procedencia) => procedencia.id == 1) || null
        }

        if (Array.isArray(this.laboratorios) && this.laboratorios.length > 0) {
          this.laboratorioSelect = this.laboratorios.find((fabrica) => fabrica.id == 1) || null
        }

        if (Array.isArray(this.unidadesmedidas) && this.unidadesmedidas.length > 0) {
          this.unidadSelect = this.unidadesmedidas.find((unidad) => unidad.id == 1) || null
        }

        if (Array.isArray(this.sucursales) && this.sucursales.length > 0) {
          this.sucursalSelect = this.sucursales.find((sucursal) => sucursal.id == 1) || null
        }

        return
      } else {
        // Producto existente
        this.actualizar_precio_compra = false

        if (this.data_producto.es_comisionable !== undefined) {
          this.data_producto.es_comisionable = Boolean(this.data_producto.es_comisionable)
        }

        if (typeof this.data_producto.estado === 'number') {
          this.data_producto.estado = this.estados.find((e) => e.value === this.data_producto.estado) || this.estados[1] // Por defecto Activo
        }

        // Verificar que los arrays estén cargados antes de hacer .find()
        if (Array.isArray(this.grupos) && this.grupos.length > 0) {
          this.grupoSelect = this.grupos.find((grupo) => grupo.id == this.data_producto.grupo_id) || null
        }

        if (Array.isArray(this.subgrupos) && this.subgrupos.length > 0) {
          this.subgrupoSelect = this.subgrupos.find((subgrupo) => subgrupo.id == this.data_producto.subgrupo_id) || null
        }

        if (Array.isArray(this.procedencias) && this.procedencias.length > 0) {
          this.procedenciaSelect =
            this.procedencias.find((procedencia) => procedencia.id == this.data_producto.procedencia_id) || null
        }

        if (Array.isArray(this.laboratorios) && this.laboratorios.length > 0) {
          this.laboratorioSelect =
            this.laboratorios.find((fabrica) => fabrica.id == this.data_producto.fabrica_id) || null
        }

        if (Array.isArray(this.unidadesmedidas) && this.unidadesmedidas.length > 0) {
          this.unidadSelect =
            this.unidadesmedidas.find((unidad) => unidad.id == this.data_producto.unidadmedida_id) || null
        }

        if (Array.isArray(this.codigossin) && this.codigossin.length > 0) {
          this.codigoSINSelect =
            this.codigossin.find((codigo) => codigo.codigoProducto == this.data_producto.codigo_siat) || null
        }

        if (Array.isArray(this.sucursales) && this.sucursales.length > 0) {
          this.sucursalSelect = this.sucursales.find((sucursal) => sucursal.id == 1) || null
        }

        if (this.data_producto.tipo_catalogo != 1) {
          this.data_producto.comision_medico = parseFloat(this.data_producto.comision_medico ?? 0)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';

.p-invalid {
  color: #ef4444;
}

.field {
  margin-bottom: 0.5rem;
}

.estilos-card {
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }
}

.card-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 700;
  font-size: 1rem;
  color: #374151;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #6366f1;
  flex-wrap: wrap;

  i {
    color: #6366f1;
    font-size: 1.1rem;
  }

  span:first-of-type {
    flex: 1;
    min-width: 150px;
  }
}

.badge-homologado {
  background: #10b981;
  color: white;
  padding: 0.25rem 0.6rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
}

.field-checkbox {
  display: flex;
  align-items: center;

  label {
    margin-bottom: 0;
    cursor: pointer;
  }
}

/* ============================================
   RESPONSIVIDAD MÓVIL
   ============================================ */

// Tablets y pantallas medianas (768px - 991px)
@media screen and (max-width: 991px) {
  .estilos-card {
    padding: 0.875rem;
  }

  .card-header {
    font-size: 0.95rem;
    padding-bottom: 0.4rem;

    i {
      font-size: 1rem;
    }
  }
}

// Móviles grandes (576px - 767px)
@media screen and (max-width: 767px) {
  .estilos-card {
    padding: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .card-header {
    font-size: 0.9rem;
    gap: 0.4rem;
    padding-bottom: 0.4rem;

    i {
      font-size: 0.95rem;
    }

    span:first-of-type {
      font-size: 0.85rem;
    }
  }

  .badge-homologado {
    font-size: 0.7rem;
    padding: 0.2rem 0.5rem;

    i {
      font-size: 0.7rem;
    }
  }

  .field {
    margin-bottom: 0.6rem;

    strong {
      font-size: 0.875rem;
    }
  }

  // Ajustar inputs en móvil
  :deep(.p-inputtext),
  :deep(.p-dropdown),
  :deep(.p-inputnumber-input) {
    font-size: 0.875rem;
    padding: 0.5rem;
  }

  :deep(.p-button) {
    padding: 0.5rem 0.75rem;

    .pi {
      font-size: 0.875rem;
    }
  }

  // Footer del diálogo más compacto
  :deep(.p-dialog-footer) {
    padding: 0.75rem;
    gap: 0.5rem;
    flex-direction: column;

    .p-button {
      width: 100%;
      justify-content: center;
    }
  }
}

// Móviles pequeños (menos de 576px)
@media screen and (max-width: 575px) {
  .estilos-card {
    padding: 0.625rem;
    border-radius: 0.375rem;
  }

  .card-header {
    font-size: 0.85rem;
    gap: 0.35rem;
    padding-bottom: 0.35rem;
    border-bottom-width: 1.5px;

    i {
      font-size: 0.9rem;
    }

    span:first-of-type {
      font-size: 0.8rem;
    }
  }

  .badge-homologado {
    font-size: 0.65rem;
    padding: 0.15rem 0.4rem;
    margin-top: 0.25rem;
    width: 100%;
    justify-content: center;
  }

  .field {
    margin-bottom: 0.5rem;

    strong {
      font-size: 0.8rem;
      display: inline-block;
      margin-bottom: 0;
      line-height: 1.2;
      vertical-align: middle;
    }

    .p-invalid {
      display: inline-block;
      vertical-align: middle;
      margin-left: 2px;
      line-height: 1;
    }
  }

  .field-checkbox {
    label {
      font-size: 0.8rem;
    }
  }

  // Inputs más compactos en móviles pequeños
  :deep(.p-inputtext),
  :deep(.p-dropdown),
  :deep(.p-inputnumber-input),
  :deep(.p-inputtextarea) {
    font-size: 0.8rem;
    padding: 0.4rem;
  }

  :deep(.p-button) {
    padding: 0.4rem 0.6rem;
    font-size: 0.8rem;

    .pi {
      font-size: 0.8rem;
    }
  }

  :deep(.p-inputgroup) {
    .p-button {
      padding: 0.4rem 0.5rem;
    }
  }

  // Dialog más ajustado
  :deep(.p-dialog) {
    width: 95vw !important;
    max-width: 95vw !important;
    margin: 0.5rem;
  }

  :deep(.p-dialog-header) {
    padding: 0.75rem;
    font-size: 0.9rem;
  }

  :deep(.p-dialog-content) {
    padding: 0.5rem;
  }

  :deep(.p-dialog-footer) {
    padding: 0.5rem;
    gap: 0.4rem;

    .p-button-lg {
      font-size: 0.8rem;
      padding: 0.5rem;
    }
  }

  // Dropdown opciones más legibles
  :deep(.p-dropdown-item) {
    font-size: 0.8rem;
    padding: 0.5rem;
  }
}

// Modo landscape en móviles
@media screen and (max-height: 500px) and (orientation: landscape) {
  .estilos-card {
    padding: 0.5rem;
  }

  .card-header {
    font-size: 0.8rem;
    padding-bottom: 0.3rem;
  }

  .field {
    margin-bottom: 0.4rem;
  }

  :deep(.p-dialog) {
    max-height: 90vh;
  }

  :deep(.p-dialog-content) {
    max-height: calc(90vh - 120px);
    overflow-y: auto;
  }
}

/* ============================================
   MEJORAS ADICIONALES
   ============================================ */

// Animación suave para campos inválidos
.p-invalid {
  animation: shake 0.3s ease-in-out;
}

@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
}

// Mejor visualización de campos deshabilitados
:deep(.p-disabled) {
  opacity: 0.6;
  cursor: not-allowed;
}

// Scroll personalizado para áreas largas
:deep(.p-dialog-content) {
  scrollbar-width: thin;
  scrollbar-color: #6366f1 #e5e7eb;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #e5e7eb;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #6366f1;
    border-radius: 3px;

    &:hover {
      background: #4f46e5;
    }
  }
}

// Separación visual entre secciones en móvil
@media screen and (max-width: 767px) {
  .col-12.mt-2 {
    margin-top: 0.75rem !important;
  }
}
</style>
